export default __webpack_public_path__ + "static/media/icon_privacy_home_transparency_icon-2.8e4d6f49.svg";